export const STORE_USER = "STORE_USER";
export const USER_SIGNED_OUT = "USER_SIGNED_OUT";
export const USER_EXPIRED = "USER_EXPIRED";
export const STORE_USER_ERROR = "STORE_USER_ERROR";
export const LOADING_USER = "LOADING_USER";

export const STORE_CITIZEN_INFO = "STORE_CITIZEN_INFO";
export const LOAD_CITIZEN_INFO = "LOAD_CITIZEN_INFO";

export const SET_TICKET_TYPE = "SET_TICKET_TYPE";
export const GET_TICKET_TYPE = "GET_TICKET_TYPE";
